export default __webpack_public_path__ + "static/1-b9d01718b14036bd7e6436b9fb0b1cac.jpg";